<h1 mat-dialog-title fxLayoutAlign="center" *ngIf="!noHeader">
  {{ action ? capitalizeFirst(action) : 'Are you sure you want to cancel your changes?' }}
</h1>

<div mat-dialog-content>
  {{ action ? setAction() : '' }}
  {{
    !action
      ? 'Cancelling your changes on this step will delete any entered information on this step. All previous steps have been saved.'
      : ''
  }}
</div>

<div mat-dialog-actions align='end'>
  <button mat-button (click)='cancelClose()'>{{ negative }}</button>
  <button mat-raised-button class='app-mid-margin-right' color="primary" (click)='positiveActionClose()'>{{ positive }}</button>
</div>
